import { getModalStyle } from '@/utils/Modal';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid
} from '@mui/material';

import {
    Close as CloseIcon,
    RemoveRedEye as ViewIcon,
    Redo as PlanInIcon,
    Undo as PlanOutIcon,
    Engineering as MaintenanceIcon
} from '@mui/icons-material';

import { date } from '@/utils/Dates';

export default function ResourceEventsModal({t, open, setOpen, fullScreen, event, resource, openUrlModal}){

	const { sxDialog/*, sxCloseIcon*/ } = getModalStyle();

    const handleClose = () => {
        setOpen(false);
    }

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialog}
            onClose={handleClose}
            open={open}
            fullWidth={true}            
        >                        
        	<DialogTitle className='modal-title'>
                {resource?.name}
            </DialogTitle>            
            <DialogContent className='modal-content text-center'>
                <div 
                    key={'resource_rental_event_info_'+event?.id}
                    className=''
                >
                    <div className='resource-rental-event-info-title'>
                        {t('resource_rentals.history.fields.type')}
                    </div>
                    <div className='resource-rental-event-info-content'>
                        {
                            event?.status?.type && event?.status?.type?.length > 0 ?
                                <>
                                <div className='me-1'>
                                    {
                                        event.status.type === 'planin'?
                                            <PlanInIcon color='error'/>
                                        :
                                            event.status.type === 'planout' ?
                                                <PlanOutIcon color='success'/>
                                            :
                                                event.status.type === 'maintenancein' ?
                                                    <MaintenanceIcon color='error'/>
                                                :
                                                    <MaintenanceIcon color='success'/>

                                    }
                                </div>
                                <div>
                                    {t('resource_rentals.history.type.'+event?.status?.type)}
                                </div>
                                </>
                            :
                                '-'
                        }
                    </div>
                    {
                        event?.plan?.name && event?.plan?.name?.length > 0 &&
                        <>
                        <div className='resource-rental-event-info-title'>
                            {t('resource_rentals.history.fields.plan')}
                        </div>
                        <div className='resource-rental-event-info-content'>
                            {
                                event?.plan_url && event?.plan_url?.length > 0 ?
                                    <a href={event.plan_url} target='_blank'>{event?.plan?.name}</a>
                                :
                                    event?.plan?.name
                            }
                        </div>
                        </>
                    }
                    <div className='resource-rental-event-info-title'>
                        {t('resource_rentals.history.fields.date')}
                    </div>
                    <div className='resource-rental-event-info-content'>
                        {date(event?.date,true,true)}
                    </div>
                    <div className='resource-rental-event-info-title'>
                        {t('resource_rentals.history.fields.responsible')}
                    </div>
                    <div className='resource-rental-event-info-content'>
                        {
                            event?.user?.name && event?.user?.name?.length > 0 ?  
                                event?.user?.name
                            :
                                '-'
                        }
                    </div>
                    {
                        event?.description && event?.description?.length > 0 &&
                        <>
                        <div className='resource-rental-event-info-title'>
                            {t('resource_rentals.history.fields.observations')}
                        </div>                            
                        <div className='resource-rental-event-info-content'>
                            {event?.description}
                        </div>
                        </>
                    }
                    {
                        event?.files && event?.files?.length > 0 &&
                        <>
                        <div className='resource-rental-event-info-title'>
                            {t('resource_rentals.history.fields.images')}
                        </div>                            
                        <div className='resource-rental-event-info-content pt-2'>
                            {
                                event?.files && event?.files?.length > 0 &&                                
                                <Grid
                                    container
                                    //spacing={2}
                                    rowSpacing={0}
                                    columnSpacing={2}
                                    className='flex justify-center items-center'
                                >
                                    {
                                        event.files?.map((file,index) => (
                                            <Grid 
                                                key={'resource_rental_event_info_file_'+index} 
                                                size={{ xs:12, sm:12, md: 6, xl: 4 }}
                                                className='border rounded h-50 flex items-center justify-center'
                                            >
                                                <a
                                                    className='cursor-pointer'
                                                    onClick={() => openUrlModal(file?.path,true,file?.type,file?.mime,file?.name,'','',false,false)}>
                                                    {
                                                        file.type === 'image' ? 
                                                            <img className='p-2 h-50' src={file?.path}/>
                                                        :
                                                            file.type === 'pdf' ?
                                                                <div className='w-full h-full'>
                                                                    <iframe                                                                                                        
                                                                        src={file?.path}                    
                                                                        style={{width:'100%', height: '100%', pointerEvents: 'none'}}
                                                                    ></iframe>
                                                                </div>
                                                            :
                                                                <div className=''><ViewIcon fontSize='large'/></div>
                                                    }                                    
                                                </a>
                                            </Grid>
                                        ))
                                    }
                                </Grid>        
                            } 
                        </div>
                        </>
                    } 
                </div>
            </DialogContent>            
            <div className="modal-buttons">                
                <div className=''>
                    <CloseIcon className='action-button-modal text-black' onClick={handleClose}/>
                </div>
            </div>        
        </Dialog>
  );
}